var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({staticStyle:{"flex":"1"},attrs:{"disabled":_vm.disabled,"large":"","color":`${_vm.$vuetify.theme.dark ? ' secondary' : 'primary'}`}},'v-btn',{ [_vm.buttonVariantKey]: true },false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }